import React, { useState } from 'react'
import { Fetch } from '../../services/api'
import { arrMeses, notify, ObtenerFechaActual, urlApiPlamin } from '../../utils/utils'
import MatrizOperativa from '../../app/pages/gestionOperacional/MatrizOperativa/Index'

export const useMatrizOperativa = () => {
  const [columnasPivotMatrizOperativa, setColumnasPivotMatrizOperativa] = useState([])
  const [filasMatrizOperativa, setFilasMatrizOperativa] = useState([])
  const [agrupadoPorMesYAnio, setAgrupadoPorMesYAnio] = useState({})
  const fechaActual = ObtenerFechaActual()

  const listarMatrizOperativa = async (fechaInicio = fechaActual, fechaFin = fechaActual) => {
    const response = await Fetch({
      url: urlApiPlamin + '/matrizOperativa?' + new URLSearchParams({
        fechaInicio: fechaInicio,
        fechaFin: fechaFin
      })
    });
    if(response.isValid){
      const columnasPivot = response.content.columnasPivot
      const columnasPivotFormateadas = columnasPivot.map(elem => {
        const [anio, mes, dia] =  elem.split('-')
        return {
          anio: anio,
          mes: arrMeses[Number(mes)-1],
          mesNumero: mes,
          dia: dia
        }
      })
      const arrPorAnio = Object.groupBy(columnasPivotFormateadas, elem => elem.anio);
      const arrPorAnioYMes = Object.fromEntries(Object.entries(arrPorAnio).map(([key, value],i) => {
        const agrupadoPorMes = Object.groupBy(value, elem => elem.mes)
        return [key,agrupadoPorMes];
      }));
      console.log("arrPorAnio -> ",arrPorAnio)
      console.log("arrPorAnioYMes -> ",arrPorAnioYMes)
      setAgrupadoPorMesYAnio(arrPorAnioYMes)
      setColumnasPivotMatrizOperativa(response.content.columnasPivot)
      setFilasMatrizOperativa(response.content.filasReporte)
    }else{
      notify(response.exceptions[0].description, 'error')
    }
  }
  
  return {
    listarMatrizOperativa,
    columnasPivotMatrizOperativa,
    filasMatrizOperativa,
    agrupadoPorMesYAnio
  }
}
